require('./angulartics');
module.exports = 'angulartics';



//////////////////
// WEBPACK FOOTER
// ../~/angulartics/src/index.js
// module id = 109
// module chunks = 0